import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import bgImage from "../../assets/login.jpeg";
import { API_BASE_URL } from "../../utils/adminApi";
import "./AdminAuth.css";

function AdminRegister() {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleRegister = async () => {
    if (loading) return;
    setError("");

    try {
      setLoading(true);
      await axios.post(`${API_BASE_URL}/api/admin/register`, { name, email, password });
      const loginRes = await axios.post(`${API_BASE_URL}/api/admin/login`, { email, password });
      sessionStorage.setItem("token", loginRes.data.token);
      sessionStorage.setItem("adminUser", JSON.stringify(loginRes.data.admin));
      navigate("/admin/dashboard", { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="auth-wrapper"
      style={{
        background: `linear-gradient(rgba(15,23,42,0.85), rgba(15,23,42,0.85)), url(${bgImage})`,
      }}
    >
      <div className="auth-card">
        <div className="brand-logo">
          <h2>
            BookMy<span>Repair</span>
          </h2>
        </div>

        <h3>Register Admin</h3>
        <p className="subtitle">Set up a new staff or admin account</p>

        <div className="auth-form-group">
          <input
            type="text"
            placeholder="Full Name"
            className="auth-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        <div className="auth-form-group">
          <input
            type="email"
            name="admin-email"
            autoComplete="off"
            placeholder="Admin Email"
            className="auth-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className="auth-form-group">
          <div className="auth-input-wrap">
            <input
              type={showPassword ? "text" : "password"}
              name="admin-password"
              autoComplete="new-password"
              placeholder="Password"
              className="auth-input auth-input-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button
              type="button"
              className="password-toggle"
              onClick={() => setShowPassword((prev) => !prev)}
              aria-label={showPassword ? "Hide password" : "Show password"}
              aria-pressed={showPassword}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
        </div>

        {error ? (
          <p className="subtitle" style={{ color: "#ef4444", marginBottom: "8px" }}>
            {error}
          </p>
        ) : null}

        <button className="auth-btn" onClick={handleRegister} disabled={loading}>
          {loading ? "Registering..." : "Complete Registration"}
        </button>

        <div className="auth-footer">
          Already have an account?
          <span className="auth-link" onClick={() => navigate("/admin/login", { replace: true })}>
            Log in
          </span>
        </div>
      </div>
    </div>
  );
}

export default AdminRegister;
